<template>
  <footer class="content-padd-x" :class="{ isMobile }">
    <nav class="footer-content content-width">
      <div>
        <a href="https://www.gov.pl/web/gunb/" target="_blank">
          <img
            class="block logo"
            alt="Logo GUNB"
            src="/img/GUNB_logo.svg"
          />
        </a>
      </div>
      <div class="copyright">© 2025 Główny Urząd Nadzoru Budowlanego</div>
      <div class="footer-links">
        <a class="footer-link mx-2 mx-lg-5" href="/deklaracja-dostepnosci">
          Deklaracja dostępności
        </a>
        <a class="footer-link mx-2 mx-lg-5" href="/polityka-prywatnosci">
          Polityka prywatności
        </a>
      </div>
      <div class="socials">
        <a href="https://www.linkedin.com/company/gunb" target="_blank">
          <img
            :height="isMobile ? 38 : 50"
            src="/img/linkedin.svg"
            alt="logo linkedin"
          />
        </a>
        <a href="https://twitter.com/GUNB_Urzad" target="_blank">
          <img
            :height="isMobile ? 38 : 50"
            src="/img/x.svg"
            alt="logo twitter"
          />
        </a>
        <a
          href="https://www.youtube.com/channel/UCE6OMf81seJQ1NCf107U_Eg"
          target="_blank"
        >
          <img
            :height="isMobile ? 38 : 50"
            src="/img/youtube.svg"
            alt="logo youtube"
          />
        </a>
      </div>
    </nav>
  </footer>
</template>

<script>
export default {
  name: "LibFooter"
};
</script>

<style scoped lang="scss">
$gap: 20px;

.logo {
  width: 264px;
}
footer {
  border-top: 1px solid #eee;
}
.footer-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding-top: 38px;
  padding-bottom: 38px;
  column-gap: 10px;
  row-gap: $gap;
  img {
    display: block;
  }
}

.copyright {
  font-size: 0.875rem;
  color: #3d3d40;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  row-gap: $gap;
  justify-content: center;
}

a.footer-link {
  color: var(--c-primary-blue);
  font-weight: 500;
  text-decoration: none;
  text-align: center;
  &:hover {
    text-decoration: underline;
  }
}

.socials {
  display: flex;
  gap: 10px;
  a {
    transition: 0.3s opacity;
  }
  a:hover {
    opacity: 0.8;
  }
}

.isMobile {
  .footer-content {
    flex-direction: column;
    padding-top: 24px;
    padding-bottom: 24px;
  }
  .logo {
    width: 220px;
  }
}
</style>
